<div class="p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
             {{stepDetails?.name}}


        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        
      </div>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>


        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})" 
                  [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
                  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>

       
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <form [formGroup]="benchmarkForm">

     <div class="row mb-4">
       <div class="col-md-4 d-flex gap-2">
              <label class="bg-primary text-white p-2 " for="bid_opening_date">Technical Bid Opening Date <b class="text-warning">*</b></label>
      <input inputId="bid_opening_date" type="date" formControlName="bid_opening_date" [disabled]="isEditorDisabled"  class="w-100px" />
      </div>
      <div class="col-md-4 d-flex gap-2">
              <label class="bg-primary text-white p-2 " for="bid_opening_time">Technical Bid Opening Time <b class="text-warning">*</b></label>
             <input inputId="bid_opening_time" type="time" formControlName="bid_opening_time" [disabled]="isEditorDisabled"  class="w-100px" />
      </div>
       <div class="col-md-4 d-flex gap-2">
             <label class="bg-primary text-white p-2 " for="technical_bid_venue">Technical Bid Opening Venue <b class="text-warning">*</b></label>
      <input inputId="technical_bid_venue" formControlName="technical_bid_venue" [disabled]="true" class="w-100px" />
      </div>
    </div>
    <div class="col-md-6 d-flex gap-4">
      <label class="bg-primary text-white p-2 " for="benchmark_price">Benchmark Price <b class="text-warning">*</b></label>
      <input inputId="benchmark_price" formControlName="benchmark_price" [disabled]="true" class="w-100px" />
    </div>

    <!-- <div class="form-group mb-4 editor-container mt-4" [class.readonly-editor]="isEditorDisabled">
      <label class="bg-primary text-white p-2 " for="pdsTitle"><strong>• Justification</strong></label>
      <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled">
      </editor>
    </div> -->
  </form>
   <div class="mt-3 mb-4">
    <div *ngIf="stepDetails?.can_edit" class="d-flex justify-content-end mb-2">
      <button class="add-btn bg-primary text-white py-2 px-3" (click)="addBenchmarkDateRow()">+ Add Row</button>
    </div>
    <table class="custom-table table mb-4">
      <thead>
        <tr>
          <th class="bg-primary text-white py-2">Benchmarking Meeting</th>
          <th class="bg-primary text-white py-2">Held On</th>
          <th *ngIf="stepDetails?.can_edit" class="bg-primary text-white py-2">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of benchmarkDates; let i = index">
          <td>
            <ng-container *ngIf="row.edit; else nameDisplay">
              <input type="text" class="form-control" [(ngModel)]="row.name" />
            </ng-container>
            <ng-template #nameDisplay>{{ row.name }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="row.edit; else dateDisplay">
              <input type="date" class="form-control" [(ngModel)]="row.date" />
            </ng-container>
            <ng-template #dateDisplay>{{ row.date }}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="stepDetails?.can_edit">
              <button class="btn btn-sm btn-outline-primary me-1" *ngIf="!row.edit" (click)="row.edit = true">Edit</button>
              <button class="btn btn-sm btn-success" *ngIf="row.edit" (click)="saveBenchmarkDateRow(row)">Save</button>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
   <form [formGroup]="benchmarkForm">

    <div class="form-group mb-4 editor-container mt-4" [class.readonly-editor]="isEditorDisabled">
      <label class="bg-primary text-white p-2 " for="pdsTitle"><strong>• Justification</strong></label>
      <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled">
      </editor>
    </div>
  </form>
</div>

<!-- Document Upload Section -->
  <div class="mt-4 mb-4">
    <app-upload-document [isEditable]="stepDetails?.can_edit"  [title]="stepDetails?.name"></app-upload-document>
  </div>


